module.exports = __webpack_public_path__ + "assets/img/xjthree.341b084c.png";